import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ext, fileClass, targetCodes, ownerInitials, avatarPalette,
    formatDue, dueClass, progressOf, statusFor, projectName,
} from './projectHelpers';

const BOARD_COLS = [
    ['queued', 'Queued'],
    ['live', 'In progress'],
    ['review', 'In review'],
    ['blocked', 'Blocked'],
    ['done', 'Done'],
];

const BoardCard = ({ p }) => {
    const navigate = useNavigate();
    const e = ext(p);
    const pct = progressOf(p);
    const targets = targetCodes(p).slice(0, 4);
    const status = statusFor(p);
    const owners = (p.collaborators || p.assignedTo || []).slice(0, 3);
    return (
        <div
            role="button"
            tabIndex={0}
            onClick={() => navigate(`/dashboard/projects/${p._id}`)}
            style={{ background: 'var(--bg-card)', border: '1px solid var(--line)', borderRadius: 10, padding: 12, display: 'flex', flexDirection: 'column', gap: 8, cursor: 'pointer' }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span className={`fic ${fileClass(e)}`} style={{ width: 24, height: 24, borderRadius: 6, fontSize: 9, display: 'grid', placeItems: 'center', fontWeight: 700 }}>{e}</span>
                <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{projectName(p)}</span>
            </div>
            <div className="p-langs" style={{ fontSize: 10 }}>
                {targets.map((l) => <span key={l} className="p-lang">{l}</span>)}
            </div>
            <div className="p-prog">
                <span className="bar"><span style={{ width: `${pct}%` }} /></span>
                <span className="pct">{pct}%</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="p-owners">
                    {owners.map((o, i) => (
                        <span key={i} className={`av-s ${avatarPalette(i)}`} style={{ width: 20, height: 20, fontSize: 9 }}>
                            {ownerInitials(o, i)}
                        </span>
                    ))}
                </div>
                <span className={`p-due ${dueClass(p.deadline, status)}`} style={{ fontSize: 11 }}>{formatDue(p.deadline)}</span>
            </div>
        </div>
    );
};

const BoardView = ({ rows }) => (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12, alignItems: 'start' }}>
        {BOARD_COLS.map(([key, label]) => {
            const items = rows.filter((r) => statusFor(r) === key);
            return (
                <div key={key} style={{ background: 'var(--bg-soft)', border: '1px solid var(--line)', borderRadius: 12, padding: 12, display: 'flex', flexDirection: 'column', gap: 8, minHeight: 220 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '2px 4px 8px' }}>
                        <span className={`p-status ${key}`}><span className="pulse" />{label}</span>
                        <span style={{ marginLeft: 'auto', fontSize: 11.5, color: 'var(--ink-4)', fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
                            {items.length}
                        </span>
                    </div>
                    {items.map((p) => <BoardCard key={p._id} p={p} />)}
                </div>
            );
        })}
    </div>
);

export default BoardView;
